module.exports = __webpack_public_path__ + "img/SRN.3e72ffd6.svg";